import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { ModalComponent } from '../../modal/modal.component';
import { TimeToRepairPluginService } from './timetorepair-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'timetorepair-edit',
    templateUrl: './timetorepair-edit.component.html',
    standalone: false
})
export class TimeToRepairEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public currentItem: any;
  editForm: UntypedFormGroup;
  public processing = false;

  @ViewChild('reparatorModal', { static: true })
  modal: ModalComponent;
  public timeToRepairs: any;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  public reparators: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: TimeToRepairPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service
      .updateTimeToRepair(
        this.inspectionId,
        this.pointId,
        this.pluginId,
        _.map(model.timetorepairs, (el: any) => ({
          Reparator: el.Reparator,
          Hours: el.Hours,
          Minutes: el.Minutes,
          CustomReparator: el.CustomReparator
        }))
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.reparators = _.orderBy(this.service.getReparators(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.timeToRepairs =
        this.plugin.config.TimeToRepairs != null
          ? this.plugin.config.TimeToRepairs.map((el: any) => {
              return {
                Reparator: el.Reparator,
                Hours: el.Hours,
                Minutes: el.Minutes,
                CustomReparator: el.CustomReparator
              };
            })
          : [];
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['timetorepairs'];
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['timetorepairs'];
    control.removeAt(i);
  }

  public openReparatorSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.modal, this.reparators, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['timetorepairs'];
    this.currentItem = control.controls[i];
  }

  public selectReparatorMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Reparator'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Reparator'].setValue(selectedIndex);
    if (selectedIndex === 99) this.currentItem.controls['CustomReparator'].enable();
    else {
      this.currentItem.controls['CustomReparator'].setValue(null);
      this.currentItem.controls['CustomReparator'].disable();
    }
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['timetorepairs'];
    control.push(this.initTimeToRepair());
  }

  initTimeToRepair(el?: any) {
    let reparator = '';
    if (el) {
      reparator = this.service.getReparators().some((r) => r.value === el.Reparator) ? el.Reparator : '';
    }
    let group = this.fb.group({
      Reparator: [reparator, Validators.required],
      Hours: [el ? el.Hours : 0],
      Minutes: [el ? el.Minutes : 0],
      CustomReparator: [el && el.CustomReparator ? el.CustomReparator : '']
    });
    if (group.get('Reparator').value !== 99) group.get('CustomReparator').disable();
    return group;
  }

  initForm() {
    this.editForm = this.fb.group({
      timetorepairs: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['timetorepairs'];
    _.forEach(this.timeToRepairs, (el) => {
      control.push(this.initTimeToRepair(el));
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
